import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { ApplicationsIdSchema } from '../applications.schema';
import {
  ApplicationInteractionListQuerySchema,
  ApplicationInteractionListResponseSchema,
} from './application-interactions.schema';

export const ApplicationInteractionsContractRoutes = {
  listApplicationInteractions: terraContract
    .meta({
      openApi: true,
      permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
    })
    .route({
      method: 'GET',
      path: '/{id}/interactions',
      summary: 'List application interactions',
      description:
        'Metadata-only audit of HTTP and non-HTTP touchpoints for an application (Torch traffic, cloud scans, probes, credential verification requests, and related activity). Paginated with optional filters. Response rows may include evidenceRef for HAR drill-down; bodies are not returned on this endpoint.',
      inputStructure: 'detailed',
    })
    .input(
      z.object({
        params: ApplicationsIdSchema,
        query: ApplicationInteractionListQuerySchema,
      }),
    )
    .output(ApplicationInteractionListResponseSchema),
};
